// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"84192dfc","457":"db818fbc"}[chunkId] + ".chunk.js";
};